'use es6';

import I18n from 'I18n';
const DateFormats = {
  DATE: 'date',
  TIME: 'time',
  DATE_TIME: 'dateTime'
};
export function showFromNow(ts) {
  const startOfDay = I18n.moment.portalTz().startOf('day');
  return I18n.moment.portalTz(ts).isAfter(startOfDay);
}
export function getDateTime(ts, useShowFromNow = true) {
  if (useShowFromNow && showFromNow(ts)) {
    return I18n.moment.portalTz(ts).fromNow();
  }
  return I18n.moment.portalTz(ts).format('lll');
}
export function getDate(ts) {
  if (showFromNow(ts)) {
    return I18n.moment.portalTz(ts).fromNow();
  }
  return I18n.moment.portalTz(ts).format('ll');
}
export function getTime(ts) {
  if (showFromNow(ts)) {
    return null;
  }
  return I18n.moment.portalTz(ts).format('LT');
}
export function getDateWithFormat(ts, dateFormat) {
  let formatted;
  switch (dateFormat) {
    case DateFormats.DATE:
      formatted = getDate(ts);
      break;
    case DateFormats.TIME:
      formatted = getTime(ts);
      break;
    case DateFormats.DATE_TIME:
    default:
      formatted = getDateTime(ts);
  }
  return formatted;
}